import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './box-cta.module.css';
import { BoxCTAContent } from './box-cta-content';
export const BoxCTALabel = ({ size = 'large', variant = 'primary', wide, className, children, leftSlot, rightSlot })=>{
    const ctaClasses = classNames(styles.cta, styles[variant], styles[size], wide && styles.wide, className);
    return /*#__PURE__*/ _jsx("span", {
        className: ctaClasses,
        children: /*#__PURE__*/ _jsx(BoxCTAContent, {
            leftSlot: leftSlot,
            rightSlot: rightSlot,
            children: children
        })
    });
};

//# sourceMappingURL=box-cta-label.js.map